<section class="ava-product" id="ava">
  <div class="ava-product__inner">

    <div class="ava-product__badge">{{ 'AVA_PRODUCT.BADGE' | translate }}</div>

    <div class="ava-product__header">
      <div class="ava-product__text">
        <h2>{{ 'AVA_PRODUCT.TITLE' | translate }}</h2>
        <p class="ava-product__subtitle">{{ 'AVA_PRODUCT.SUBTITLE' | translate }}</p>
        <p class="ava-product__description">{{ 'AVA_PRODUCT.DESCRIPTION' | translate }}</p>

        <div class="ava-product__features">
          <span *ngFor="let key of featureKeys">{{ ('AVA_PRODUCT.FEATURES.' + key) | translate }}</span>
        </div>

        <p class="ava-product__tech">
          <strong>{{ 'AVA_PRODUCT.TECH_LABEL' | translate }}</strong>
          {{ 'AVA_PRODUCT.TECH' | translate }}
        </p>

        <a href="https://www.avatel.io/" target="_blank" rel="noopener" class="ava-product__cta">
          {{ 'AVA_PRODUCT.CTA' | translate }}
        </a>
      </div>

      <div class="ava-product__visual">
        <div class="ava-product__logo-box">
          <span class="ava-product__logo-icon">📞</span>
          <span class="ava-product__logo-name">AVA</span>
          <span class="ava-product__logo-sub">by CloudFusion IT</span>
        </div>
        <div class="ava-product__stats">
          <div class="stat">
            <strong>24/7</strong>
            <span>{{ 'AVA_PRODUCT.STAT1' | translate }}</span>
          </div>
          <div class="stat">
            <strong>2 min</strong>
            <span>{{ 'AVA_PRODUCT.STAT2' | translate }}</span>
          </div>
          <div class="stat">
            <strong>ab 40€</strong>
            <span>{{ 'AVA_PRODUCT.STAT3' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
